import { createContext, useContext, useState, useCallback, type ReactNode } from 'react';

const MultiSelectActiveContext = createContext(false);
const MultiSelectSetterContext = createContext<(active: boolean) => void>(() => {});

export function MultiSelectProvider({ children }: { children: ReactNode }) {
  const [active, setActiveState] = useState(false);
  const setActive = useCallback((v: boolean) => setActiveState(v), []);

  return (
    <MultiSelectSetterContext.Provider value={setActive}>
      <MultiSelectActiveContext.Provider value={active}>
        {children}
      </MultiSelectActiveContext.Provider>
    </MultiSelectSetterContext.Provider>
  );
}

export function useMultiSelectActive() {
  return useContext(MultiSelectActiveContext);
}

export function useSetMultiSelectActive() {
  return useContext(MultiSelectSetterContext);
}
